const en_vaillant = {
  WELCOME_TO_NEMURU: "Welcome",
};

export default en_vaillant;
